var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MglMarker',{attrs:{"coordinates":_vm.coordinates,"anchor":"center"}},[_c('div',{attrs:{"slot":"marker"},slot:"marker"},[_c('StatusDot',{staticClass:"marker",attrs:{"fillColor":"#f19938","size":32,"strokeWidth":5}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }